import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

import posthog from 'posthog-js';
import { PostHogProvider } from '@posthog/react';

const phToken = import.meta.env.VITE_PUBLIC_POSTHOG_TOKEN;
if (phToken) {
  posthog.init(phToken, {
    api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
    autocapture: false,
    disable_session_recording: false,
    session_recording: {
      maskAllInputs: true,
      maskTextSelector: '[data-private]',
    },
    capture_pageview: true,
    capture_pageleave: true,
    capture_performance: false,
    // App.addError calls posthog.captureException with richer properties
    // (status, code, url, method) — leaving auto-capture on would double-fire.
    capture_exceptions: false,
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <PostHogProvider client={posthog}>
      <App />
    </PostHogProvider>
  // </React.StrictMode>
);

serviceWorkerRegistration.register();